<template>  
  <VUEModal :Titolo="Titolo" 
            :Programma="''" 
            :Altezza="AltezzaPopup" 
            :Larghezza="'500px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickChiudiModal"
            @OnClickConfermaModal="OnClickConfermaModal">

    <template v-slot:Body>
<!-- messo altezzza popup perché su schermi piccoli fa un macello altrimenti -->
      <VUEModal :Titolo="this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MONTAGGIO_GV',this.LinguaUtente)"
                  :Altezza="AltezzaPopup"
                  Larghezza="1500px" 
                  :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
                  @onClickChiudiModal="OnClickChiudiModalMontaggioGV"
                  v-if="PopupConfigMontaggioGV">
        <template v-slot:Body>
          <VUEComponenteGraficoGV :OggettoMontaggioGV="OggettoTemporaneoMontaggioGV"
                                  :VettoreModuli="ModuliGrafico"
                                  :VisualizzaSoloImmagine="false"/>
        </template>
        <template v-slot:Footer>
          <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:18%" @click="OnClickChiudiModalMontaggioGV" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
          <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:18%" @click="OnClickConfermaOggettoMontaggioGV" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
        </template>
      </VUEModal>


      <div class="ZMNuovaRigaScheda" style="display:flex">
        <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 0%; margin-top: 0%;">
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente) }}</label>
          <div style="width:20px;float:left">&nbsp;</div> 
          <input :placeholder="this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente)" class="form-control" type="text" style="float: left; width: calc(60%)" v-model="NomeElemento">
        </div>
      </div>      

      <div class="col-md-12" v-if="NomeElemento == ''">
        <div style="float:left;width:3%;">&nbsp;</div>
        <label style="font-size:12px;margin-left: 33%;" class="ZMFormLabelError">{{ this.GetTraduzioneLabel('Generic','TKN_ERR_NOME',this.LinguaUtente) }}</label>
      </div>

      <div class="ZMNuovaRigaScheda" style="display:flex">
        <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 0%; margin-top: 0%;">
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_SEL_GRAF',this.LinguaUtente) }}</label>
          <div style="width:20px;float:left">&nbsp;</div> 
          <select style="width:60%" class="form-control" v-model="Elemento">
            
            <option v-for="(Modulo, chiave) in FiltraModuliSpeciali" :key="chiave" :value="Modulo">{{ GetModuloDescr(Modulo) }}</option>
            
            <optgroup label="Grafici attuali" class="option-group">
              <option v-for="(Modulo, chiave) in FiltraModuliAbbinati" :key="chiave" :value="Modulo">{{ GetModuloDescr(Modulo) }}</option>
            </optgroup>

            <optgroup label="Grafici storici" class="option-group">
              <option v-for="(Modulo, chiave) in FiltraModuliStorici" :key="chiave" :value="Modulo">{{ GetModuloDescr(Modulo) }}</option>
            </optgroup>

          </select>
        </div>
      </div>

      <div class="col-md-12" v-if="Elemento === ''">
        <div style="float:left;width:3%;">&nbsp;</div>
        <label style="font-size:12px;margin-left: 33%;" class="ZMFormLabelError">{{ this.GetTraduzioneLabel('Generic','TKN_ERR_ELEMENTO',this.LinguaUtente) }}</label>
      </div>

      <div v-if="IsLarghezzaModificabile" class="ZMNuovaRigaScheda" style="display:flex">
        <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 0%; margin-top: 0%;">
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_LARGHEZZA',this.LinguaUtente) }}</label>
          <div style="width:20px;float:left">&nbsp;</div> 
          <input :placeholder="this.GetTraduzioneLabel('Generic','TKN_LARGHEZZA',this.LinguaUtente)" class="form-control" type="text" style="float: left; width: calc(60%)" v-model="LarghezzaElemento">
        </div>
      </div>

      <div class="col-md-12" v-if="IsLarghezzaModificabile && (LarghezzaElemento == '' || LarghezzaElemento == 0)">
        <div style="float:left;width:3%;">&nbsp;</div>
        <label style="font-size:12px;margin-left: 33%;" class="ZMFormLabelError">{{ this.GetTraduzioneLabel('Generic','TKN_ERR_LARGHEZZA',this.LinguaUtente) }}</label>
      </div>

      <div v-if="IsGraficoStorico" class="ZMNuovaRigaScheda" style="display:flex">
        <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 0%; margin-top: 0%;">
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_MODULI',this.LinguaUtente) }}</label>
          <div style="width:20px;float:left">&nbsp;</div> 
          <button type="button" class="btn btn-info" style="float: left; width: calc(60%);font-weight:bold" @click="OnClickSelezionaModuli">{{ this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_SEL_MODULI',this.LinguaUtente) }}</button>
        </div>
      </div>

      <div class="col-md-12" v-if="IsGraficoStorico && !IsModuliInseriti">
        <div style="float:left;width:3%;">&nbsp;</div>
        <label style="font-size:12px;margin-left: 33%;" class="ZMFormLabelError">{{ this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_ERR_MODULI',this.LinguaUtente) }}</label>
      </div>

      <div v-if="IsGraficoOrientato" class="ZMNuovaRigaScheda" style="display:flex">
        <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 0%; margin-top: 0%;">
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_ORIENTAMENTO',this.LinguaUtente) }}</label>
          <div style="width:20px;float:left">&nbsp;</div> 
          <input class="form-control" type="text" style="float: left; width: calc(60%)" v-model="OrientamentoElemento">
        </div>
      </div>

      <div v-if="IsGraficoStorico" class="ZMNuovaRigaScheda" style="display:flex">
        <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 0%; margin-top: 0%;">
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_LUNGH_TEMP',this.LinguaUtente) }}</label>
          <div style="width:20px;float:left">&nbsp;</div> 
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;font-weight: normal;width: 10%;">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente)}}</label>
          <div style="width:20px;float:left">&nbsp;</div> 
          <input :placeholder="this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente)" class="form-control" type="text" style="float: left; width: calc(45%)" v-model="LunghezzaTemporaleGiorni">
        </div>
      </div>

      <div v-if="IsGraficoStorico" class="ZMNuovaRigaScheda" style="display:flex">
        <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 0%; margin-top: -2%;">
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">&nbsp;</label>
          <div style="width:20px;float:left">&nbsp;</div> 
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;font-weight: normal;width: 10%;">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE',this.LinguaUtente) }}</label>
          <div style="width:20px;float:left">&nbsp;</div> 
          <input :placeholder="this.GetTraduzioneLabel('UdmGenerali','TKN_ORE',this.LinguaUtente)" class="form-control" type="text" style="float: left; width: calc(45%)" v-model="LunghezzaTemporaleOre">
        </div>
      </div>

      <div class="col-md-12" v-if="IsGraficoStorico && (LunghezzaTemporaleGiorni === '' || LunghezzaTemporaleOre === '' || (LunghezzaTemporaleOre == 0 && LunghezzaTemporaleGiorni == 0))">
        <div style="float:left;width:3%;">&nbsp;</div>
        <label style="font-size:12px;margin-left: 33%;" class="ZMFormLabelError">{{ this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_ERR_LUNGH_TEMP',this.LinguaUtente) }}</label>
      </div>

      <div v-if="IsCampioniRilevati" class="ZMNuovaRigaScheda" style="display:flex;margin-bottom: -1%;">
        <div class="ZMDivPopupContent" style="width: 50%; margin-bottom: 0%; margin-top: 0%;">
          <input class="form-control" type="checkbox" style="float: left; width: calc(7%);margin-top: 1%;" v-model="MostraPitch">
          <div style="width:3%;float:left">&nbsp;</div> 
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;width: 37%">{{ this.GetTraduzioneLabel('Generic','TKN_PITCH',this.LinguaUtente) }}</label>
          <div style="width:4%;float:left">&nbsp;</div> 
          <div class="ZMColorPickerDiv" style="float:left;width:42%;margin-top:8px;" :style="{'background-color' : ColorePitch}" @click="ApriPopupColorPickerPitch()">&nbsp;</div>
        </div>
        <div class="ZMDivPopupContent" style="width: 50%; margin-bottom: 0%; margin-top: 0%;">
          <input class="form-control" type="checkbox" style="float: left; width: calc(7%);margin-top: 1%;" v-model="MostraPiezo">
          <div style="width:3%;float:left">&nbsp;</div> 
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;width: 45%">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_PIEZOMETRI',this.LinguaUtente) }}</label>
          <div style="width:3%;float:left">&nbsp;</div> 
          <div class="ZMColorPickerDiv" style="float:left;width:42%;margin-top:8px;" :style="{'background-color' : ColorePiezo}" @click="ApriPopupColorPickerPiezo()">&nbsp;</div>
        </div>
      </div>

      <div v-if="IsGraficoTempoModif" class="ZMNuovaRigaScheda" style="display:flex;margin-bottom: -1%;">
        <div class="ZMDivPopupContent" style="width: 50%; margin-bottom: 0%; margin-top: 0%;">
          <input class="form-control" type="checkbox" style="float: left; width: calc(7%);margin-top: 1%;" v-model="GraficoGiornaliero">
          <div style="width:3%;float:left">&nbsp;</div> 
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;width: 83%">{{ this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_GRAFICO_GIORNALIERO',this.LinguaUtente) }}</label>
        </div>
        <div class="ZMDivPopupContent" style="width: 50%; margin-bottom: 0%; margin-top: 0%;">
          <input class="form-control" type="checkbox" style="float: left; width: calc(7%);margin-top: 1%;" v-model="GraficoOrario">
          <div style="width:3%;float:left">&nbsp;</div> 
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;width: 83%">{{ this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_GRAFICO_ORARIO',this.LinguaUtente) }}</label>
        </div>
      </div>

      <div v-if="IsCampioniRilevati" class="ZMNuovaRigaScheda" style="display:flex;margin-bottom: -1%;">
        <div class="ZMDivPopupContent" style="width: 50%; margin-bottom: 0%; margin-top: 0%;">
          <input class="form-control" type="checkbox" style="float: left; width: calc(7%);margin-top: 1%;" v-model="MostraRoll">
          <div style="width:3%;float:left">&nbsp;</div> 
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;width: 37%">{{ this.GetTraduzioneLabel('Generic','TKN_ROLL',this.LinguaUtente) }}</label>
          <div style="width:4%;float:left">&nbsp;</div> 
          <div class="ZMColorPickerDiv" style="float:left;width:42%;margin-top:8px;" :style="{'background-color' : ColoreRoll}" @click="ApriPopupColorPickerRoll()">&nbsp;</div>
        </div>
        <div class="ZMDivPopupContent" style="width: 50%; margin-bottom: 0%; margin-top: 0%;">
          <input class="form-control" type="checkbox" style="float: left; width: calc(7%);margin-top: 1%;" v-model="MostraEst">
          <div style="width:3%;float:left">&nbsp;</div> 
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;width: 45%">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_ESTENSIMETRI',this.LinguaUtente) }}</label>
          <div style="width:3%;float:left">&nbsp;</div> 
          <div class="ZMColorPickerDiv" style="float:left;width:42%;margin-top:8px;" :style="{'background-color' : ColoreEst}" @click="ApriPopupColorPickerEst()">&nbsp;</div>
        </div>
      </div>

      <div v-if="IsCampioniRilevati" class="ZMNuovaRigaScheda" style="display:flex">
        <div class="ZMDivPopupContent" style="width: 50%; margin-bottom: 0%; margin-top: 0%;">
          <input class="form-control" type="checkbox" style="float: left; width: calc(7%);margin-top: 1%;" v-model="MostraTemp">
          <div style="width:3%;float:left">&nbsp;</div> 
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;width: 37%">{{ this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) }}</label>
          <div style="width:4%;float:left">&nbsp;</div> 
          <div class="ZMColorPickerDiv" style="float:left;width:42%;margin-top:8px;" :style="{'background-color' : ColoreTemp}" @click="ApriPopupColorPickerTemp()">&nbsp;</div>
        </div>
        <div class="ZMDivPopupContent" style="width: 50%; margin-bottom: 0%; margin-top: 0%;">
          <input class="form-control" type="checkbox" style="float: left; width: calc(7%);margin-top: 1%;" v-model="MostraMarkup">
          <div style="width:3%;float:left">&nbsp;</div> 
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;width: 90%">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_MOSTRA_MARKUP',this.LinguaUtente) }}</label>
        </div>
      </div>   

      <div v-if="IsMontaggioGV" class="ZMNuovaRigaScheda" style="display:flex">
        <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 0%; margin-top: 0%;">
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">&nbsp;</label>
          <div style="width:20px;float:left">&nbsp;</div> 
          <button type="button" class="btn btn-info" style="float: left; width: calc(60%);font-weight:bold" @click="OnClickModificaConfigurazioneGV">{{ this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_DATI_STORICI_MODIFICA_GV',this.LinguaUtente) }}</button>
        </div>
      </div>     

      <VUEPopupSelezionaModuli v-if="PopupScegliModuli" 
                                :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_SEL_MODULI',this.LinguaUtente) + ']'" 
                                :AltezzaPopup="AltezzaPopup" 
                                :VettoreModuli="ModuliGrafico"
                                :MostraColori="Elemento !== Moduli.CampRilevati && Elemento !== Moduli.EvAccAmpiezza"
                                :ColoreTotale="ColoreTotale"
                                :MostraTotale="MostraTotale"
                                :IsGraficoConTotali="IsGraficoConTotali"
                                @OnClickConfermaPopup="OnClickConfermaModuli"
                                @OnClickChiudiPopup="OnClickChiudiPopupChiudiModuli"/>

    </template>
   
    <template  v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickChiudiModal" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CanRecord()" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="OnClickConfermaModal"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
 
  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>

</template>

<script>  

import VUEModal from '@/utils/VUEModal.vue';            
import { SystemInformation, TIPI_MODULI } from '@/SystemInformation'
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import VUEPopupSelezionaModuli from '../../components/Popups/VUEPopupSelezionaModuli.vue';
import VUEComponenteGraficoGV, { TMontaggioGV } from '../../components/Slots/VUEComponenteGraficoGV.vue';

export default 
{
  data()
  {
   return {
            LinguaUtente             : SystemInformation.UserInformation.Lingua,
            JSONCurrentGrafici       : {},
            Moduli                   : TIPI_MODULI,
            Elemento                 : '',
            NomeElemento             : '',
            LarghezzaElemento        : '',
            LunghezzaTemporaleGiorni : '',
            LunghezzaTemporaleOre    : '',
            ColorePitch              : '',
            ColorePiezo              : '',
            ColoreRoll               : '',
            ColoreEst                : '',
            ColoreTemp               : '',
            CurrentColoreInModifica  : '',
            ColoreTotale             : '',
            ColoreInModifica         : {},
            OrientamentoElemento     : 0,
            PopupColorPicker         : false,
            IsModuliInseriti         : false,
            IsLarghezzaModificabile  : false,
            IsImmagine               : false,
            IsGraficoStorico         : false,
            IsGraficoOrientato       : false,
            IsCampioniRilevati       : false,
            IsGraficoConTotali       : false,
            IsGraficoTempoModif      : false,
            PopupScegliModuli        : false,
            GraficoGiornaliero       : false,
            GraficoOrario            : false,
            MostraPitch              : false,
            MostraPiezo              : false,
            MostraRoll               : false,
            MostraEst                : false,
            MostraTemp               : false,
            MostraMarkup             : false,
            MostraTotale             : false,
            IsMontaggioGV            : false,
            PopupConfigMontaggioGV   : false,
            OggettoTemporaneoMontaggioGV : new TMontaggioGV(),
          }
  },

  props : ['AltezzaPopup', 'Titolo', 'ObjGrafici', 'VettoreModuli', 'IsEstensimetroPresente'],
  emits : ['OnClickChiudiPopup', 'OnClickConfermaPopup'],
  mixins: [MixInsGestioneTraduzioni],
  components: { 
                VUEModal,
                VUEPopupSelezionaModuli,
                VUEColorPicker,
                VUEComponenteGraficoGV,
              },

  methods :
  {
    OnClickChiudiModal()
    {
      this.$emit('OnClickChiudiPopup')
    },

    OnClickSelezionaModuli()
    {
      this.PopupScegliModuli = true
    },

    OnClickChiudiPopupChiudiModuli()
    {
      this.PopupScegliModuli = false
    },

    OnClickConfermaModuli(ObjModuli, ColoreTotale, MostraTotale)
    {
      this.ColoreTotale = ColoreTotale
      this.MostraTotale = MostraTotale
      this.ModuliGrafico = ObjModuli
      this.JSONCurrentGrafici.MODULI = ObjModuli
      this.IsModuliInseriti = ObjModuli.some(Elemento => Elemento.Selezionato) || MostraTotale
      this.PopupScegliModuli         = false
    },

    ApriPopupColorPickerPitch()
    {
      this.CurrentColoreInModifica = 'Pitch'
      this.ColoreInModifica.Colore = this.ColorePitch
      this.ColoreInModifica.ModuloInModifica = this.ColorePitch
      this.PopupColorPicker = true
    },

    ApriPopupColorPickerRoll()
    {
      this.CurrentColoreInModifica = 'Roll'
      this.ColoreInModifica.Colore = this.ColoreRoll
      this.ColoreInModifica.ModuloInModifica = this.ColoreRoll
      this.PopupColorPicker = true
    },

    ApriPopupColorPickerTemp()
    {
      this.CurrentColoreInModifica = 'Temp'
      this.ColoreInModifica.Colore = this.ColoreTemp
      this.ColoreInModifica.ModuloInModifica = this.ColoreTemp
      this.PopupColorPicker = true
    },

    ApriPopupColorPickerPiezo()
    {
      this.CurrentColoreInModifica = 'Piezo'
      this.ColoreInModifica.Colore = this.ColorePiezo
      this.ColoreInModifica.ModuloInModifica = this.ColorePiezo
      this.PopupColorPicker = true
    },

    ApriPopupColorPickerEst()
    {
      this.CurrentColoreInModifica = 'Est'
      this.ColoreInModifica.Colore = this.ColoreEst
      this.ColoreInModifica.ModuloInModifica = this.ColoreEst
      this.PopupColorPicker = true
    },

    ConfermaColore()
    { 
      switch(this.CurrentColoreInModifica)
      {
        case('Pitch') : { 
                          this.ColorePitch = this.ColoreInModifica.Colore
                          break
                        }
        case('Roll') : { 
                          this.ColoreRoll = this.ColoreInModifica.Colore
                          break
                        }
        case('Temp') : { 
                          this.ColoreTemp = this.ColoreInModifica.Colore
                          break
                        }
        case('Piezo') : { 
                          this.ColorePiezo = this.ColoreInModifica.Colore
                          break
                        }
        case('Est') : { 
                          this.ColoreEst = this.ColoreInModifica.Colore
                          break
                        }
      }
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    GetModuloDescr(Modulo)
    {
        let Result = ''
        switch(Modulo)
        {
          case (this.Moduli.Polare)         : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_POLARE',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.SpostEst)       : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_S_E',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.SpostNord)      : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_S_N',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.SpostTot)       : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_S_T',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.SpostAzimuth)   : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_AZIMUTH',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Temperatura)    : {
                                                Result = this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Deformazione)   : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_DEF',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Piezometro)     : {
                                                Result = this.GetTraduzioneLabel('Generic','TKN_PIEZOMETRO',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Spacer)         : {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_SPACER',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.InfoGenerali)   : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_INFO_GEN',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Abbinati)       : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_GRAF_ABB',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Allineamento)   : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_RIALL_DATA',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Immagine)       : {
                                                Result = this.GetTraduzioneLabel('Generic','TKN_IMMAGINE',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.CampRilevati)   : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_RILEVATI',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Spostamenti)    : {
                                                Result = this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTI',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Velocità)       : {
                                                Result = this.GetTraduzioneLabel('Generic','TKN_VELOCITA',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Accelerazione)  : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ACCELERAZIONE',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Assorbimento)   : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ASSORB',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.TensAlim)       : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_TENSIONE_ALIM',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.MontaggioGV)    : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MONTAGGIO_GV',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.EvAccAmpiezza)  : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_AMPIEZZA_XYZ',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.EvAccFrequenza) : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_FREQ_MODULO',this.LinguaUtente)
                                                break;
                                              }
          case (this.Moduli.ProfiloLong)    : {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_BAND_PROFILO_LONG',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.TemperaturaO)   : {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_BAND_TEMPERATURA_O',this.LinguaUtente)
                                                break
                                              }                        
          case (this.Moduli.DeformazioneO)  : {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_BAND_DEFORMAZIONE_O',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.ProfiloLongAll) : {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_BAND_PROFILO_LONG_ALL',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.DeformazioneOAll): {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_BAND_DEFORMAZIONE_O_ALL',this.LinguaUtente)
                                                break
                                              }
        }
        return Result
    },

    OnClickConfermaModal()
    {
      this.$emit('OnClickConfermaPopup', this.JSONCurrentGrafici)
    },

    ControlloLarghezza()
    {
      let Result = true
      if(this.IsLarghezzaModificabile && (this.LarghezzaElemento == 0 || this.LarghezzaElemento == ''))
        Result = false
      return Result
    },

    ControlloStorici()
    {
      let Result = true
      if(this.IsGraficoStorico && (this.LunghezzaTemporaleGiorni === '' || this.LunghezzaTemporaleOre === '' || (this.LunghezzaTemporaleOre == 0 && this.LunghezzaTemporaleGiorni == 0))) 
        Result = false
      return Result
    },

    CanRecord()
    {
      return this.Elemento !== '' && this.NomeElemento !== '' && this.ControlloLarghezza() && this.ControlloStorici() && this.IsModuliInseriti
    },

    OnClickModificaConfigurazioneGV()
    {
      this.PopupConfigMontaggioGV = true
    },

    OnClickChiudiModalMontaggioGV()
    {
      TZGenericFunct.GetCopyOfObject(this.JSONCurrentGrafici.CONFIGURAZIONE_GRAFICO_GV, this.OggettoTemporaneoMontaggioGV)
      // this.OggettoTemporaneoMontaggioGV.VettoreSoglieDiAllarme.forEach(Soglia =>
      // {
      //   Soglia.Eliminato = false 
      // })
      this.PopupConfigMontaggioGV = false
    },

    OnClickConfermaOggettoMontaggioGV()
    {
      for(let i = 0; i < this.OggettoTemporaneoMontaggioGV.VettoreSoglieDiAllarme.length; i++)
      {
        if(this.OggettoTemporaneoMontaggioGV.VettoreSoglieDiAllarme[i].Eliminato)
        {
          this.OggettoTemporaneoMontaggioGV.VettoreSoglieDiAllarme.splice(i, 1)
          i--;
        }
      }
      // this.JSONCurrentGrafici.CONFIGURAZIONE_GRAFICO_GV = this.OggettoTemporaneoMontaggioGV
      TZGenericFunct.GetCopyOfObject(this.OggettoTemporaneoMontaggioGV, this.JSONCurrentGrafici.CONFIGURAZIONE_GRAFICO_GV)
      this.PopupConfigMontaggioGV = false
    },
  },

  watch:
  {
    Elemento:
    {
      handler(NewValue, OldValue)
      {
        if(NewValue !== '')
        {
          this.JSONCurrentGrafici.ELEMENTO  = NewValue

          if(OldValue != '')
          {
            this.LarghezzaElemento         = ''
            this.LunghezzaTemporaleGiorni  = ''
            this.LunghezzaTemporaleOre     = ''
            this.OrientamentoElemento      = 0 
            this.ModuliGrafico             = this.VettoreModuli
            this.ColorePitch               = 'purple'
            this.ColoreRoll                = 'green'
            this.ColoreTemp                = 'red'
            this.ColorePiezo               = 'blue'
            this.ColoreEst                 = 'brown'
            this.ColoreTotale              = TZGenericFunct.GenerateRandomColor(['#FFFFFF, #ffffff'])
            this.GraficoGiornaliero        = true
            this.GraficoOrario             = false
            this.MostraPitch               = true
            this.MostraRoll                = true
            this.MostraTemp                = true
            this.MostraPiezo               = false
            this.MostraEst                 = false
            this.MostraMarkup              = false
            this.MostraTotale              = false
          }
        }

        if(NewValue == this.Moduli.CampRilevati ||
           NewValue == this.Moduli.Spostamenti ||
           NewValue == this.Moduli.Velocità ||
           NewValue == this.Moduli.Accelerazione ||
           NewValue == this.Moduli.Assorbimento ||
           NewValue == this.Moduli.TensAlim ||
           NewValue == this.Moduli.EvAccAmpiezza ||
           NewValue == this.Moduli.EvAccFrequenza)
        {
          this.IsGraficoStorico = true
          if(OldValue != '')
            this.IsModuliInseriti = false
        }
        else
        {
          this.IsGraficoStorico = false
          this.IsModuliInseriti = true
        }

        if(NewValue == this.Moduli.CampRilevati ||
           NewValue == this.Moduli.Spostamenti ||
           NewValue == this.Moduli.Velocità ||
           NewValue == this.Moduli.Accelerazione)
        {
          this.IsGraficoOrientato = true
        }
        else
        {
          this.IsGraficoOrientato = false
        }

        if(NewValue == this.Moduli.Spostamenti ||
           NewValue == this.Moduli.Velocità ||
           NewValue == this.Moduli.Accelerazione)
        {
          this.IsGraficoConTotali = true
          if(NewValue == this.Moduli.Velocità ||
             NewValue == this.Moduli.Accelerazione)
          {
            this.IsGraficoTempoModif = true
          }
          else
          {
            this.IsGraficoTempoModif = false
          }
        }
        else
        {
          this.IsGraficoConTotali = false
          this.IsGraficoTempoModif     = false
        }

        if(NewValue == this.Moduli.CampRilevati)
        {
          this.IsCampioniRilevati = true
        }
        else
        {
          this.IsCampioniRilevati = false
        }
        
        if(NewValue == this.Moduli.MontaggioGV)
        {
          this.IsMontaggioGV = true
        }
        else
        {
          this.IsMontaggioGV = false
        }

        if(NewValue == this.Moduli.Immagine)
        {
          this.IsImmagine = true
        }
        else
        {
          this.IsImmagine = false
        }

        if(
           NewValue == this.Moduli.InfoGenerali ||
           NewValue == this.Moduli.Abbinati ||
           NewValue == this.Moduli.Allineamento ||
           NewValue == this.Moduli.Polare ||
           NewValue == this.Moduli.SpostEst ||
           NewValue == this.Moduli.SpostNord ||
           NewValue == this.Moduli.SpostTot ||
           NewValue == this.Moduli.SpostAzimuth ||
           NewValue == this.Moduli.Temperatura ||
           NewValue == this.Moduli.Deformazione ||
           NewValue == this.Moduli.Piezometro ||
           NewValue == this.Moduli.Spacer ||
           NewValue == this.Moduli.CampRilevati ||
           NewValue == this.Moduli.Spostamenti ||
           NewValue == this.Moduli.Velocità ||
           NewValue == this.Moduli.Accelerazione ||
           NewValue == this.Moduli.Assorbimento ||
           NewValue == this.Moduli.TensAlim ||
           NewValue == this.Moduli.Immagine ||
           NewValue == this.Moduli.MontaggioGV ||
           NewValue == this.Moduli.EvAccAmpiezza ||
           NewValue == this.Moduli.EvAccFrequenza ||
           NewValue == this.Moduli.ProfiloLong ||
           NewValue == this.Moduli.TemperaturaO ||
           NewValue == this.Moduli.DeformazioneO ||
           NewValue == this.Moduli.ProfiloLongAll ||
           NewValue == this.Moduli.DeformazioneOAll)
        {
          this.IsLarghezzaModificabile = true
        }
        else
        {
          this.IsLarghezzaModificabile = false
          // if(this.Moduli.InfoGenerali)
          //   this.LarghezzaElemento = 13

          // if(this.Moduli.Abbinati)
          //   this.LarghezzaElemento = 18
          
          // if(this.Moduli.Allineamento)
          //   this.LarghezzaElemento = 15
        } 
      }
    },

    NomeElemento:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.NOME_ELEMENTO = NewValue
      }
    },

    LunghezzaTemporaleOre:
    {
      handler(NewValue)
      {
        if(NewValue != '')
        {
          if (isNaN(NewValue) || NewValue < 0) 
          {
            this.JSONCurrentGrafici.LUNGHEZZA_TEMPORALE_ORE = 0;
            this.LunghezzaTemporaleOre = 0
          }
          else 
          {
            this.JSONCurrentGrafici.LUNGHEZZA_TEMPORALE_ORE = Math.max(0, Math.min(23, Math.floor(Number(NewValue))))
            this.LunghezzaTemporaleOre = Math.max(0, Math.min(23, Math.floor(Number(NewValue))))
          }
        }
      }
    },

    LunghezzaTemporaleGiorni:
    {
      handler(NewValue)
      {
        if(NewValue != '')
        {
          if (isNaN(NewValue) || NewValue < 0) 
          {
            this.JSONCurrentGrafici.LUNGHEZZA_TEMPORALE_GIORNI = 0;
            this.LunghezzaTemporaleGiorni = 0
          }
          else 
          {
            this.JSONCurrentGrafici.LUNGHEZZA_TEMPORALE_GIORNI = Math.max(0, Math.min(30, Math.floor(Number(NewValue))))
            this.LunghezzaTemporaleGiorni = Math.max(0, Math.min(30, Math.floor(Number(NewValue))))
          }
        }
      }
    },

    LarghezzaElemento:
    {
      handler(NewValue)
      {
        if(NewValue != '')
        {
          if (isNaN(NewValue) || NewValue < 0) 
          {
            this.JSONCurrentGrafici.LARGHEZZA = 0;
            this.LarghezzaElemento = 0
          }
          else this.JSONCurrentGrafici.LARGHEZZA = Number(NewValue);
        }
      }
    },

    OrientamentoElemento:
    {
      handler(NewValue)
      {
        if(NewValue != '')
        {
          if (isNaN(NewValue) || NewValue < 0)
          {
            this.JSONCurrentGrafici.ORIENTAMENTO = 0;
            this.OrientamentoElemento = 0
          }
          else
          {
            this.JSONCurrentGrafici.ORIENTAMENTO = Math.max(0, Math.min(359.99, parseFloat(NewValue)));
            this.OrientamentoElemento = Math.max(0, Math.min(359.99, parseFloat(NewValue)));
          }
        }
      }
    },

    ColorePitch:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.COLORE_PITCH = NewValue
      }
    },

    ColoreRoll:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.COLORE_ROLL = NewValue
      }
    },

    ColoreTemp:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.COLORE_TEMP = NewValue
      }
    },

    ColorePiezo:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.COLORE_PIEZO = NewValue
      }
    },

    ColoreEst:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.COLORE_EST = NewValue
      }
    },

    MostraPitch:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.MOSTRA_PITCH = NewValue
      }
    },

    MostraRoll:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.MOSTRA_ROLL = NewValue
      }
    },

    GraficoGiornaliero:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.IS_GIORNALIERO = NewValue
        this.GraficoOrario = !NewValue
      }
    },

    GraficoOrario:
    {
      handler(NewValue)
      {
        this.GraficoGiornaliero = !NewValue
      }
    },

    MostraTemp:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.MOSTRA_TEMP = NewValue
      }
    },

    MostraPiezo:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.MOSTRA_PIEZO = NewValue
      }
    },

    MostraEst:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.MOSTRA_EST = NewValue
      }
    },

    MostraMarkup:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.MOSTRA_MARKUP = NewValue
      }
    },

    MostraTotale:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.MOSTRA_TOTALE = NewValue
      }
    },

    ColoreTotale:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentGrafici.COLORE_TOTALE = NewValue
      }
    }

  },

  computed: 
  {

    FiltraModuliAbbinati()
    {
      const Abbinati = [this.Moduli.Polare, this.Moduli.SpostEst, this.Moduli.SpostNord, this.Moduli.SpostTot, this.Moduli.SpostAzimuth, this.Moduli.Temperatura, this.Moduli.Deformazione, this.Moduli.Piezometro, this.Moduli.TemperaturaO, this.Moduli.ProfiloLong, this.Moduli.DeformazioneO, this.Moduli.ProfiloLongAll, this.Moduli.DeformazioneOAll]
      return Object.fromEntries(Object.entries(this.Moduli).filter(([, valore]) => Abbinati.includes(valore)))
    },

    FiltraModuliSpeciali() 
    {
      const Speciali = [this.Moduli.InfoGenerali, this.Moduli.Abbinati, this.Moduli.Allineamento, this.Moduli.Immagine, this.Moduli.Spacer, this.Moduli.MontaggioGV]
      return Object.fromEntries(Object.entries(this.Moduli).filter(([, valore]) => Speciali.includes(valore)))
    },

    FiltraModuliStorici() 
    {
      const Storici = [this.Moduli.CampRilevati, this.Moduli.Spostamenti, this.Moduli.Velocità, this.Moduli.Accelerazione, this.Moduli.Assorbimento, this.Moduli.TensAlim, this.Moduli.EvAccAmpiezza, this.Moduli.EvAccFrequenza]
      return Object.fromEntries(Object.entries(this.Moduli).filter(([, valore]) => Storici.includes(valore)))
    }
  },

  beforeMount()
  {
    this.JSONCurrentGrafici       = JSON.parse(JSON.stringify(this.ObjGrafici))
    this.NomeElemento             = this.ObjGrafici.NOME_ELEMENTO
    this.Elemento                 = this.ObjGrafici.ELEMENTO
    this.LarghezzaElemento        = this.ObjGrafici.LARGHEZZA
    this.LunghezzaTemporaleGiorni = this.ObjGrafici.LUNGHEZZA_TEMPORALE_GIORNI
    this.LunghezzaTemporaleOre    = this.ObjGrafici.LUNGHEZZA_TEMPORALE_ORE
    this.GraficoGiornaliero       = this.ObjGrafici.IS_GIORNALIERO
    this.GraficoOrario            = !this.ObjGrafici.IS_GIORNALIERO
    this.MostraPitch              = this.ObjGrafici.MOSTRA_PITCH   
    this.MostraRoll               = this.ObjGrafici.MOSTRA_ROLL
    this.MostraTemp               = this.ObjGrafici.MOSTRA_TEMP
    this.MostraPiezo              = this.ObjGrafici.MOSTRA_PIEZO
    this.MostraEst                = this.ObjGrafici.MOSTRA_EST
    this.MostraMarkup             = this.ObjGrafici.MOSTRA_MARKUP
    this.MostraTotale             = this.ObjGrafici.MOSTRA_TOTALE
    this.OrientamentoElemento     = this.ObjGrafici.ORIENTAMENTO
    this.ColorePitch              = this.ObjGrafici.COLORE_PITCH
    this.ColoreRoll               = this.ObjGrafici.COLORE_ROLL
    this.ColoreTemp               = this.ObjGrafici.COLORE_TEMP
    this.ColorePiezo              = this.ObjGrafici.COLORE_PIEZO
    this.ColoreEst                = this.ObjGrafici.COLORE_EST
    this.ColoreTotale             = this.ObjGrafici.COLORE_TOTALE

    if(this.ObjGrafici.CONFIGURAZIONE_GRAFICO_GV != undefined)
      this.OggettoTemporaneoMontaggioGV = this.ObjGrafici.CONFIGURAZIONE_GRAFICO_GV
      
    this.ColoreTotale             = this.ObjGrafici.COLORE_TOTALE

    if(this.ObjGrafici.MODULI != '')
    {
      this.ModuliGrafico    = this.ObjGrafici.MODULI
      this.IsModuliInseriti = true
    }
    else this.ModuliGrafico = this.VettoreModuli

    if(!this.IsEstensimetroPresente)
    {
      delete this.Moduli.Deformazione
    }
  }
  
}
</script>